<template>
  <div style="display: flex; flex-direction: column; width: 100vw; height: 100vh; background: var(--background); color: var(--foreground)">
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
